import { Injectable } from '@angular/core';
import { NgxConfigureService } from 'ngx-configure';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  public config: any;

  constructor(configService: NgxConfigureService) {
    this.config = configService.config;
  }

  private getPropertyFromConfigOrDefaultValue(prop: string, defaultValue: any): typeof defaultValue {
    const value = this.config[prop];
    if (!value) {
      return defaultValue;
    }
    return value;
  }

  getAlwaysDisplayedCurrencies(): Array<string> {
    return this.getPropertyFromConfigOrDefaultValue('currencies', []);
  }

  getCurrencyPrecisions() {
    return this.getPropertyFromConfigOrDefaultValue('CurrencyDecimalPrecision', {});
  }

  getCurrencyRoundingScale() {
    return this.getPropertyFromConfigOrDefaultValue('CurrencyRoundingScale', {});
  }

  getMaxAllocationAmountPercentage() {
    return this.getPropertyFromConfigOrDefaultValue('MaxAllocationAmountPercentage', 95);
  }
}
